import React from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { FormWidgets, Touchspin } from "../../../Constant";
import { Container, Row } from "reactstrap";
import DefaultTouchspin from "./DefaultTouchspin";
import OutlinedTouchspin from "./OutlinedTouchspin";
import IconsWithPrefixAndPostfix from "./IconsWithPrefixAndPostfix";
import ButtonsWithPrefixAndPostfix from "./ButtonsWithPrefixAndPostfix";
import RoundedTouchspin from "./RoundedTouchspin";

const TouchspinContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Touchspin} parent={FormWidgets} title={Touchspin} />
      <Container fluid>
        <div className="bootstrap-touchspin">
          <Row>
            <DefaultTouchspin />
            <OutlinedTouchspin/>
            <IconsWithPrefixAndPostfix/>
            <ButtonsWithPrefixAndPostfix/>
            <RoundedTouchspin/>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TouchspinContainer;
